import { cn } from "@/shared/lib/cn";

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  className?: string;
}

/** Inline-SVG спарклайн без либ. currentColor — цвет наследуется. */
export function Sparkline({
  data,
  width = 80,
  height = 22,
  className,
}: SparklineProps): JSX.Element | null {
  if (!data || data.length < 2) return null;
  const max = Math.max(...data, 1);
  const step = width / (data.length - 1);
  const points = data
    .map((v, i) => `${(i * step).toFixed(1)},${(height - (v / max) * (height - 2) - 1).toFixed(1)}`)
    .join(" ");
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={cn("inline-block align-middle", className)}
      aria-hidden
    >
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
      />
    </svg>
  );
}
